<template>
	<div>
		<ul>
			<li :class="{'active_interest' : pickInterest == 'cheap'}" @click="changeInterest('cheap')">Cheapest</li>
			<li :class="{'active_interest' : pickInterest == 'fast'}" @click="changeInterest('fast')">Fastest</li>
			<li :class="{'active_interest' : pickInterest == 'best'}" @click="changeInterest('best')">Best rated</li>
		</ul>
	</div>
</template>

<script>
	export default{
	  data(){
		return{

		}
	  },
	  props:['pickInterest'],
	  methods : {
	    changeInterest(value){
	  	this.$emit('changeInterest',value);
	    }
	  }
    }

</script>

<style lang="scss" scoped>
	ul {
	width: 68%;
    margin: 0 auto;
    padding-left: 6px;
    padding-right: 6px;
    margin-bottom: 20px;
    background: #F5F5F5;
    height: 58px;
    overflow: hidden;
    border-radius: 100px;
    box-sizing: border-box;
    display: flex;
    vertical-align: center;
    justify-content: space-between;
    margin-top: 36px;
    margin-bottom: 58px; 
	}

	li {
    flex-grow: 1;
	  letter-spacing: 0.028em;
        font-size: 16px;
        text-align: center;
        display: inline-block;
        padding: 12px 2px;
        border-radius: 50px;
        cursor: pointer;
        font-family: 'Avenir Next';
        font-weight: 600;
        height: 46px;
        box-sizing: border-box;
        margin-top: 6px;

      &.active_interest {
      	background: #0cc3ca;
    	color: #fff;
    	overflow: hidden;
    	-webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
    	-moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
    	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
    	border-radius: 50px;
    	padding: 12px 2px;
    	cursor: default;
    	font-weight: 600;
      }
      &:hover:not(.active_interest) {
        color: #000000;
      }
	}
</style>


// WEBPACK FOOTER //
// src/components/PickInterestFull.vue